import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import ReactLoading from "react-loading";
import { useParams } from "react-router-dom";
import useAxios from "../../hooks/useAxios";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import BASE from "../../config";

const HRDashboard = () => {
  const { dashboardId } = useParams();
  const [load, setLoad] = useState(false);
  const [error, setError] = useState("");
  const api = useAxios();
  const { SUPERSET_URL } = BASE;
  const getGasToken = async () => {
    setError("")
    setLoad(true)
    try {
      const result = await api.get(`/analytics/dashboard/${dashboardId}`, {
        tokenType: "user",
      });
      const { token } = result.data;
      embedDashboard({
        id: dashboardId,
        supersetDomain: SUPERSET_URL,
        mountPoint: document.getElementById("superset-container"),
        fetchGuestToken: () => token,
        iframeTitle:"",
        dashboardUiConfig: {
          hideTitle: true,
          hideTab: true,
          hideChartControls: true,
          filters: {
              visible: true,
              expanded: false,
          },
          urlParams: {
            filtersVisible: true
          },
        },
      });
    } catch (err) {
      console.error(err);
      setError("Something went wrong")
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (!dashboardId) {
      setError("Dashboard Id is Missing.")
      return;
    } 
    getGasToken();

    const container = document.getElementById("superset-container");
    if (container) {
      const observer = new MutationObserver((mutations) => {
        console.log(mutations)
        for (const mutation of mutations) {
          if (mutation.addedNodes.length) {
            const iframe = container.querySelector("iframe");
            if (iframe) {
              iframe.style.width = '100%';
              iframe.style.minHeight = '85vh';
              observer.disconnect();
            }
          }
        }
      });
      
      observer.observe(container, { childList: true, subtree: true });
      
      return () => observer.disconnect();
    }

  }, [dashboardId]);


  return (
    <Dashboard title="Documents">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div
        id="superset-container"
        style={{ width: "100%", height: "85vh" }}
      >
        {
          error && <h4>{error}</h4>
        }
      </div>
    </Dashboard>
  );
};

export default HRDashboard;
